module.exports = __webpack_public_path__ + "img/service2.f43f7617.jpg";